export type LinkReason = {
  type: string
  anchor_keys?: string[]
  matched_keys?: string[]
  anchor_value?: string
  matched_value?: string
  rule_id?: number | null
}

export function formatLinkReasonText(reason: LinkReason | undefined): string {
  if (!reason) return ''
  const av = reason.anchor_value || ''
  const ak = reason.anchor_keys?.[0] || ''
  const mk = reason.matched_keys?.[0] || ''
  if (reason.type === 'key_alias' && reason.rule_id) {
    return `已通过规则关联：本文「${ak}」与对方「${mk}」同值「${av}」`
  }
  if (reason.type === 'same_value_cross_key' && ak && mk && ak !== mk) {
    return `通过同值「${av}」关联：本文「${ak}」↔ 对方「${mk}」`
  }
  if (ak) {
    return `通过「${ak}=${av}」关联`
  }
  return av ? `通过同值「${av}」关联` : ''
}

export function canSuggestLinkRule(reason: LinkReason | undefined): boolean {
  if (!reason || reason.rule_id) return false
  const ak = reason.anchor_keys?.[0] || ''
  const mk = reason.matched_keys?.[0] || ''
  return reason.type === 'same_value_cross_key' && !!ak && !!mk && ak !== mk
}
